<template>
  <section class="wrapper live-main"
    :class="{
        'live-main_mobile': isMobile,
    }">
    <!-- <live-sub /> -->
    <div class="live-courses clearfix">
      <div
        @click="goCourseDetail(item)"
        v-for="item in liveCourses"
        :key="item.goods_id"
        :class="item.goods_id === 0 || item.goods_id === -1 ? 'live-introduce-text' : 'live-course-item'">
        <!-- <template v-if="item.goods_id === 0 || item.goods_id === -1">
          <div class="live-introduce-title">
            How the Live Course conducts?
            <span class="underline"></span>
          </div>
          <div class="live-introduce-content">
            <h3>
              <img src="@/assets/img/comet/live/live@2x.png" alt="">
              Begin with the live form</h3>
            <p>At a preseted time, the teacher broadcasts the live signal of the Course to learners through the internet.</p>
          </div>
          <div class="live-introduce-content">
            <h3>
              <img src="@/assets/img/comet/live/replay@2x.png" alt="">
              Video replay aviliable</h3>
            <p>Video replay of the course will be provided for learners to review. You can watch the replay unlimited times with 6 months.</p>
          </div>
        </template> -->
        <template>
          <div class="live-course-list-img">
            <img  :src="item.cover" alt="123">
          </div>
          <!-- <span class="live-course-progress-tip half" v-if="item.live_broadcast_state === 1">Partially broadcast</span>
          <span class="live-course-progress-tip notstart" v-else-if="item.live_broadcast_state === 2">To be broadcast</span>
          <span class="live-course-progress-tip total" v-else-if="item.live_broadcast_state === 3">Already in replay</span> -->
          <div class="live-course-list-main">
            <h3 class="live-course-list-title">
            {{ item.title }}
            </h3>
            <p class="live-course-list-desp">
            {{ item.short_desp }}
            </p>
            <div class="underline"></div>
            <div class="live-course-list-pricebox clearfix">
            <span class="live-course-coursenum">
                {{ item.subclass_count }} {{ item.subclass_count > 1 ? $t('course.Lessons') : $t('course.Lesson') }}
            </span>
                <!-- <span class="live-course-price">${{ Number((item.price/100).toFixed(2)) }}</span>
                <span v-if="item.virtual_price" class="live-course-virtualprice">${{ Number((item.virtual_price/100).toFixed(2)) }}</span> -->
            </div>
          </div>

        </template>
      </div>
    </div>
    <!-- 因为此页面采用keepalive保持滚动位置，导致滚动组件不会销毁，故添加active属性来控制获取下一页数据 -->
    <mugen-scroll :handler="getNextPage" :should-handle="!fetching && active">
      <div class="kong-state">
        <span v-show="(liveCourses.length) < total" class="loading mini-loading"></span>
        <p v-show="(liveCourses.length) < total" style="margin-top: 50px;">{{ $t('common.Loading') }}</p>
        <p v-show="(liveCourses.length) >= total" style="margin-top: 50px;">{{ $t('course.NoMoreCourses') }}</p>
      </div>
    </mugen-scroll>
  </section>
</template>

<script>
// import LivingSubCourses from './sub/LivingSubCourses.vue'
import api from '../../api'
import MugenScroll from 'vue-mugen-scroll'

export default {
  name: 'LiveCourses',
  components: {
    // 'live-sub': LivingSubCourses,
    MugenScroll
  },
  data () {
    return {
      liveCourses: [],
      total: 0,
      pagenation: {
        current: 1,
        pageSize: 20
      },
      fetching: true,
      active: false,
      isMobile: window.innerWidth <= 768
    }
  },
  methods: {
    goCourseDetail (item) {
      if (item.goods_id === 0 || item.goods_id === -1) return
      this.$router.push({
        name: 'liveCourseDetail',
        params: {
          origin: item.goods_id
        }
      })
    },
    formatData (arr) {
      arr = JSON.parse(JSON.stringify(arr))
      arr.forEach(el => {
        if (!el.cover) {
          el.cover = this.defaultCover
        }
      })
      return arr
    },
    getNextPage () {
      if (!this.stillHasMore || this.fetching) return
      this.fetching = true
      this.pagenation.current += 1
      api.getLiveCourses({
        params: this.pagenation
      }).then(res => {
        let data = res.data
        if (data.code === 1) {
          this.liveCourses = this.liveCourses.concat(this.formatData(data.data.List))
          this.total = data.data.Total
          this.fetching = false
        } else if (data.code === 90001) {
          this.fetching = false
        } else {
          this.$toast({
            type: 'error',
            message: data.error
          })
          this.pagenation.current -= 1
          this.fetching = false
        }
      }, err => {
        this.$toast({
          type: 'error',
          message: err
        })
        this.pagenation.current -= 1
        this.fetching = false
      })
    }
  },
  mounted () {
    this.active = true
    api.getLiveCourses({
      params: this.pagenation
    }).then(res => {
      let data = res.data
      if (data.code === 1) {
        this.liveCourses = this.formatData(data.data.List)
        // this.liveCourses.splice(2, 0, {
        //   goods_id: 0
        // })
        // this.liveCourses.unshift({
        //   goods_id: -1
        // })
        this.total = data.data.Total
        this.fetching = false
      } else {
        this.$toast({
          type: 'error',
          message: data.error
        })
        this.fetching = false
      }
    }, err => {
      this.$toast({
        type: 'error',
        message: err
      })
      this.fetching = false
    })
  },
  activated () {
    this.active = true
  },
  deactivated () {
    this.active = false
  },
  computed: {
    stillHasMore () {
      return this.total > this.liveCourses.length
    }
  }
}
</script>

<style lang="scss" scoped>
// 文字超出两行显示省略号
@mixin overflowTextStyle($lines) {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $lines;
  line-clamp: $lines;
  -webkit-box-orient: vertical;
}
  .live-main.wrapper {
    padding-top: 16px;
    color: #1A3D5E;
    word-wrap: break-word;
    .live-courses {
      margin: 0 -8px 0 -7px;
      .live-introduce-text {
        // 要变成三项目布局，只需把高度切换为872px,float right
        float: left;
        width: 370px;
        height: 428px;
        margin: 0 8px 0 7px;
        background: #F7FBFF;
        margin-bottom: 16px;
        padding: 16px 16px 0;
        display: none;
        .live-introduce-title {
          font-size:18px;
          font-weight:bold;
          line-height:42px;
          position: relative;
          margin-bottom: 54px;
          .underline {
            position: absolute;
            left: 0;
            bottom: -1px;
            width:96px;
            height:2px;
            background: #37CAD7;
          }
        }
        .live-introduce-content {
          margin-bottom: 42px;
          &:last-child {
            margin-bottom: 0;
          }
          h3 {
            font-size:20px;
            font-weight:500;
            line-height:28px;
            margin-bottom: 24px;
            padding-left: 64px;
            position: relative;
            img {
              width: 46px;
              position: absolute;
              left: 0;
              top: -3px;
            }
          }
          p {
            font-size:14px;
            font-weight:400;
            color:rgba(54,85,114,1);
            line-height:22px;
          }
        }
      }
      .live-course-item {
        float: left;
        width: 370px;
        height: 428px;
        margin: 0 8px 0 7px;
        margin-bottom: 16px;
        padding: 16px;
        font-size: 0;
        border:1px solid rgba(192, 197, 201, 1);
        border-radius:2px;
        position: relative;
        transition: all .3s;
        cursor: pointer;
        &:hover {
          border:1px solid transparent;
          box-shadow:0px 2px 16px 0px rgba(35,62,114,0.07);
          transform:translateY(-5px);
        }
        .live-course-list-img {
          width: 338px;
          height: 190px;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
          margin-bottom: 20px;
        }
        .live-course-progress-tip {
          position: absolute;
          left: 8px;
          top: 24px;
          line-height: 26px;
          border-radius:2px;
          padding: 0 6px;
          font-size:12px;
          font-weight:500;
          &.half {
            background:rgba(235,249,250,1);
            color:rgba(55,202,215,1);
          }
          &.notstart {
            background:rgba(254,249,238,1);
            color:rgba(250,203,88,1);
          }
          &.total {
            background:rgba(247,251,255,1);
            color:rgba(163,177,191,1);
          }
        }
        .live-course-list-title {
          font-size:20px;
          font-family:SFProDisplay-Medium,SFProDisplay;
          font-weight:500;
          color:rgba(41,82,154,1);
          line-height:28px;
          height: 56px;
          margin-bottom: 12px;
          @include overflowTextStyle(2)
        }
        .live-course-list-desp {
          font-size:14px;
          font-weight:400;
          height: 44px;
          color:rgba(41,82,154,0.8);
          line-height:22px;
          margin-bottom: 24px;
          @include overflowTextStyle(2)
        }
        .underline {
          height:1px;
          background:rgba(239,244,250,1);
          border-radius:2px;
          margin-bottom: 20px;
        }
        .live-course-list-pricebox {
          line-height: 28px;
          .live-course-coursenum {
            padding: 8px;
            background:rgba(41,82,154,1);
            border-radius:14px;
            font-size:12px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:12px;
          }
          .live-course-price {
            float: right;
            font-size:20px;
            font-weight:500;
            color:rgba(55,202,215,1);
            margin-left: 8px;
          }
          .live-course-virtualprice {
            float: right;
            font-size:16px;
            font-weight:500;
            color:rgba(163,177,191,1);
            position: relative;
            text-decoration: line-through;
          }
        }
      }
      @media screen and(max-width: 992px) {
        .live-introduce-text {
          width: 365px;
        }
        .live-course-item {
          width: 365px;
        }
      }
      .live-introduce-text:nth-child(4) {
        display: block
      }
      @media screen and (max-width: 1200px) {
        .live-introduce-text:nth-child(1) {
          display: block;
        }
        .live-introduce-text:nth-child(4) {
          display: none;
        }
      }
    }
    .kong-state{
      text-align: center;
      font-size:14px;
      font-weight:400;
      color:#BAC4CE;
      margin-bottom: 80px;
      img{
        width: 142px;
        height: 155px;
        margin-bottom: 29px;
      }
    }
    .text-center{
      text-align: center;
    }
    .mini-loading{
      transform: scale(0.25);
    }
  }
  .live-main_mobile.wrapper {
    width: 100%;
    .live-courses {
        width: 100%;
        margin: 0;
    }
    .live-introduce-text {
        display: none!important;
    }
    .live-course-item {
        float: unset!important;
        width: 90%!important;
        min-width: 355px!important;
        margin: 0 auto 16px auto!important;
        padding: 8px!important;
        .live-course-list-main {
            width: 338px!important;
            margin: 0 auto;
        }
        // padding: calc(100% - 338)!important;
        .live-course-list-img {
            width: 338px!important;
            height: 190px!important;
            margin: 0 auto;
        }
    }
  }
</style>
